<template>
  <!-- 为什么选择我们 -->
  <div class="chooseUs" id="whyChooseUs">
    <div class="chooseUs-top">
      <img src="../assets/bigTy.png" alt="" />
      <span>{{ chooseUsList.name }}</span>
      <p>{{ chooseUsList.description }}</p>
    </div>
    <div class="chooseUs-main">
      <div
        class="chooseUs-mainBox"
        v-for="(item, index) in chooseUsList.lists"
        :key="index"
      >
        <div class="chooseUs-mainBoxLeft">
          <span>{{ item.name }}</span>
        </div>
        <div class="chooseUs-mainBoxRight">
          <span>{{ item.name2 }}</span>
        </div>
      </div>
      <div class="chooseUs-mainBox1">
        <div class="" v-for="(item, index) in chooseUsList.lists" :key="index">
          <span>{{ item.name1 }}</span>
        </div>
      </div>
      <div class="vs">
        <img src="../assets/vs.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "chooseUs",
  props: {
    chooseUsList: {
      type: Object
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.chooseUs {
  width: 1280px;
  margin: 0 auto;
  margin-top: 118px;
  margin-bottom: 104px;
}
.chooseUs-top {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 88px;
}
.chooseUs-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: -14px;
  top: -14px;
}
.chooseUs-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 14px;
}
.chooseUs-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.chooseUs-main {
  height: 480px;
  background: #f6fafb;
  border-radius: 6px;
  position: relative;
}
.chooseUs-mainBox {
  display: flex;
  justify-content: space-between;
  padding: 0 38px 0 28px;
}
.chooseUs-mainBoxLeft {
  height: 80px;
  width: 134px;
  line-height: 80px;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}
.chooseUs-mainBoxLeft:last-child {
  border: 0;
}
.chooseUs-mainBoxLeft span {
  display: block;
  padding-bottom: 30px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
  cursor: pointer;
}
.chooseUs-mainBoxLeft span:hover {
  background: linear-gradient(0deg, #dc3939 0%, #ff4242 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.chooseUs-mainBoxRight {
  height: 80px;
  width: 454px;
  line-height: 80px;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}
.chooseUs-mainBoxRight:last-child {
  border: 0;
}
.chooseUs-mainBoxRight span {
  display: block;
  padding-bottom: 28px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.chooseUs-mainBox1 {
  position: absolute;
  left: 190px;
  top: -25px;
  width: 560px;
  height: 530px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  padding: 25px 38px;
}
.chooseUs-mainBox1 div {
  height: 80px;
  width: 484px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  text-align: center;
  line-height: 80px;
}
.chooseUs-mainBox1 div:last-child {
  border: 0;
}
.chooseUs-mainBox1 div span {
  font-size: 24px;
  font-family: PingFang SC;
  /* font-weight: 600; */
  color: #ffffff;
}
.vs {
  position: absolute;
  top: 180px;
  left: 690px;
  width: 120px;
  height: 120px;
}
.vs img {
  display: block;
  width: 120px;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChooseUs.vue